export const PageNamesGA = {
  Dashboard: 'Dashboard',
  Accounts: 'Accounts',
  UnassignedPacks: 'Unassigned Packs',
  SharedPacks: 'Shared Packs',
  Catalog: 'Catalog',
  Product: 'Product',
  SearchResults: 'Search Results',
  PackViews: 'Pack Views',
  CompareProducts: 'Compare Products',
  AdminUserManagement: 'Admin User Management',
  AdminPricing: 'Admin Pricing',
  AdminMassReplace: 'Admin Mass Replace',
  AdminTemplates: 'Admin Templates',
  AdminMasterTemplateView: 'Admin Master Template View',
  AdminUnstagedPacks: 'Admin Unstaged Packs',
  MyProfile: 'My Profile',
};
